import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header1 from '../../Global/Header1'
import Banner from '../MenHomeone/Banner'
import Partner from '../MenHomeone/Partner'
import Service from '../MenHomeone/Service'
import About from '../MenHomeone/About'
import Process from '../MenHomeone/Process'
import Testimonial from '../MenHomeone/Testimonial'
import WhyChouse from '../MenHomeone/WhyChouse'
import Work from '../MenHomeone/Work'
import Team from '../MenHomeone/Team'
import Blog from '../MenHomeone/Blog'
import ContactFooter1 from '../../Global/ContactFooter1'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'

function Main() {
    return (
        <>
            <Preloader />
            <CustomCursor />
            <Header1 />
            <Banner />
            <Partner />
            <Service />
            <About />
            <Process />
            <Testimonial />
            <WhyChouse />
            <Work />
            <Team />
            <Blog />
            <ContactFooter1 />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
